import React from 'react';
import { isEmpty } from 'lodash';
import BindRecoverServer from './BindRecoverServer';
import MainServers from './MainServers';

export default function RecoverInfo({ currentCluster }) {
  // 是否是备集群
  const isRecoveryCluster = !!currentCluster?.isDisasterRecoveryCluster;

  if (isEmpty(currentCluster)) return null;

  // 如果是备集群
  if (isRecoveryCluster) {
    return <MainServers disasterRecoveryClusters={currentCluster.disasterRecoveryClusters} />;
  }

  // 主集群的情况
  return (
    <BindRecoverServer
      disasterRecoveryClusters={currentCluster.disasterRecoveryClusters}
      primaryClusterName={currentCluster?.clusterName}
      isCurrentProvideServiceCluster={currentCluster?.isCurrentProvideServiceCluster}
    />
  );
}
